export default __webpack_public_path__ + "images/IN.21014b5.png";